import classNames from 'classnames';
import React from 'react';

import Close from 'src/components/icons/close';
import MinimizeIcon from 'src/components/icons/minimize';
import type { BuildType } from 'src/enums/build/build-type';
import abby, { ABBY_CHAT_BOT_ID } from 'src/helpers/abby';
import { getABBYChatBaseUrl } from 'src/helpers/config-helper';

import * as styles from './abby-chat-bot-popup.module.scss';

const ABBY_CHAT_IFRAME_URL = (buildType: BuildType) =>
  getABBYChatBaseUrl(buildType) || 'https://app.salesape.ai/chat/texyx2yv';

const headerButtons = [
  { name: 'minimize', icon: <MinimizeIcon fill="#FFF" size={10} /> },
  { name: 'close', icon: <Close fill="#FFF" /> },
];

const AbbyChatBotPopup: React.FC<{ buildType: BuildType }> = ({ buildType }) => {
  return (
    <div id={ABBY_CHAT_BOT_ID} className={styles.popup}>
      <div className={classNames('abby-header-container', styles.container)}>
        <div className="button-controls-wrapper">
          {headerButtons.map((button) => (
            <button
              className="abby-controls-button abby-button-icon"
              type="button"
              aria-label={` ${button.name} chat`}
              key={button.name}
              onClick={abby.close}
            >
              {button.icon}
            </button>
          ))}
        </div>
      </div>
      <iframe
        src={ABBY_CHAT_IFRAME_URL(buildType)}
        width="100%"
        height="100%"
        style={{ border: 'none', flex: 1 }}
        title="ABBY Chat Bot"
        data-webkitallowfullscreen="true"
        data-mozallowfullscreen="true"
        data-oallowfullscreen="true"
        data-msallowfullscreen="true"
        allow="fullscreen"
        allowFullScreen
      />
    </div>
  );
};

export { AbbyChatBotPopup };
